module.exports = __webpack_public_path__ + "static/media/suber3.8787047b.png";